module.exports = __webpack_public_path__ + "static/media/truck-pickup.0790df83.svg";